module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "findPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Add Connection')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt, 'cz1': _vm.isCz
    },
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/back.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('connections')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    staticClass: "search",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Enter username (email)')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB),
      expression: "isB"
    }],
    staticClass: "search-result"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Search results')))]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isC),
      expression: "isC"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "result"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/User-1.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('p', [_vm._v(_vm._s(this.user.realname))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(this.user.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    on: {
      "click": _vm.request
    }
  }, [_vm._v(_vm._s(_vm.$t('Send request')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "result2"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/User-1.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('p', [_vm._v(_vm._s(this.user.realname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(this.user.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Bio')) + ": "), _c('span', {
    on: {
      "click": function($event) {
        _vm.Remark = true
      }
    }
  }, [_vm._v(_vm._s(_vm.mark))])])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    on: {
      "click": _vm.goCharts
    }
  }, [_vm._v(_vm._s(_vm.$t('View graphs')))]), _vm._v(" "), _c('button', {
    staticClass: "remove",
    on: {
      "click": _vm.Remove
    }
  }, [_vm._v(_vm._s(_vm.$t('Remove')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isE),
      expression: "isE"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "result2"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/User-1.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('p', [_vm._v(_vm._s(this.user.realname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(this.user.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "remove",
    on: {
      "click": _vm.cancelRequest
    }
  }, [_vm._v(_vm._s(_vm.$t('cancelR')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.Remark,
      "size": "tiny",
      "id": "remark-form",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.Remark = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v("Set remark")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/cancel.png")
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('p', [_vm._v("Please input remark in the following box")]), _vm._v(" "), _c('input')]), _vm._v(" "), _c('div', {
    staticClass: "patientList-dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "confirmButton"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b5794bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/care-templates/addConnect.vue
// module id = 1462
// module chunks = 7